import * as React from "react";
import TableSortingAndSelect from "../../../../component/EmplyeeAllCtcTable/employeeAllCtcTable";
import { Box, Paper, Typography, Fab, Collapse } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Animations from "../../../../component/MuiReusableComponents/AnimationLoading/animationLoading";
import { useSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import {
  notificationSelector,
  resetSnackbar,
  startSingleEmployeeAllPayrollCTC_EmployeeId,
} from "../../../../store1/payrolls data/payrollDataSlice.Selector";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

////Needed
const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: false,
    label: "S No.",
  },

  {
    id: "annual_ctc",
    numeric: false,
    disablePadding: false,
    label: "Annual CTC",
  },
  {
    id: "final_basic",
    numeric: false,
    disablePadding: false,
    label: "Basic Salary",
  },
  {
    id: "hra",
    numeric: false,
    disablePadding: false,
    label: "HRA",
  },
  {
    id: "special_allowance",
    numeric: false,
    disablePadding: false,
    label: "Special Allowance",
  },

  {
    id: "fixed",
    numeric: false,
    disablePadding: false,
    label: "Fixed Allowance",
  },

  {
    id: "added_date",
    numeric: false,
    disablePadding: false,
    label: "Revision Date",
  },
];

/////////Main Component
const EmployeeReviseListData = ({
  isLoadingPayrollData,
  setisItNewAdd,
  singleEmployeeAllCTCPayrolls,
}) => {
  const { emp_id } = useParams();
  const locationName = useLocation().pathname;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  //Selectors

  const notification = useSelector(notificationSelector);
  const { snackbarSuccess, snackbarError, errorMessage } = notification;

  const rows = singleEmployeeAllCTCPayrolls.map((item) => {
    let montlyCTC = item.annual_ctc / 12;
    let basicAmount = Math.round(montlyCTC * (item.basic / 100));
    let hraAmount = Math.round(basicAmount * (item.hra / 100));
    return {
      ...item,
      hra: hraAmount,
      fixed: Math.round(
        montlyCTC - basicAmount - hraAmount - item.special_allowance
      ),
    };
  });

  const [draftedCTC, setDraftedCTC] = React.useState({
    annual_ctc: "",
    hra: "",
    special_allowance: "",
    fixed: "",
    added_date: new Date().toDateString(),
  });

  const [filteredRows, setFilteredRows] = React.useState([]);
  const [filterStatus, setFilterStatus] = React.useState(false);
  const [openTable, setOpenTable] = React.useState(false);

  //Effect
  React.useEffect(() => {
    setFilteredRows(rows);
    let findDraft = singleEmployeeAllCTCPayrolls.find(
      (item) => item.status === 2
    );

    if (findDraft?.annual_ctc) {
      setDraftedCTC(findDraft);
    } else {
      setDraftedCTC({
        annual_ctc: "",
        hra: "",
        special_allowance: "",
        fixed: "",
        added_date: new Date().toDateString(),
      });
    }
  }, [singleEmployeeAllCTCPayrolls]);

  React.useEffect(() => {
    const myResetFun = () => {
      dispatch(resetSnackbar());
    };
    if (snackbarError) {
      enqueueSnackbar(errorMessage, { variant: "error" });
      setTimeout(myResetFun, 2000);
    }
  }, [snackbarError]);
  //
  React.useEffect(() => {
    const myResetFun = () => {
      dispatch(resetSnackbar());
    };
    if (snackbarSuccess) {
      enqueueSnackbar("Successfull", { variant: "success" });
      dispatch(startSingleEmployeeAllPayrollCTC_EmployeeId(emp_id));
      navigate(`/employee-management/payroll-management/employee-salaries/${emp_id}/revise`);
      setTimeout(myResetFun, 100);
    }
  }, [snackbarSuccess]);

  return (
    <Box sx={{ width: "100%" }}>
      {isLoadingPayrollData ? (
        <Animations />
      ) : (
        <>
          <Paper
            sx={{
              display: "flex",
              margin: "15px 0px 5px 0px",
              padding: "15px 25px 15px 15px",
              alignItems: "center"
            }}
          >
            <Typography
              gutterBottom
              sx={{ fontWeight: 600, flexGrow: 1 }}
              textAlign="center !important"
            >
              Salary Revision History
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center" }}>
              {draftedCTC.annual_ctc ? (
                <>
                  <Typography gutterBottom>Active Draft</Typography>
                  <Fab
                    color="secondary"
                    aria-label="edit"
                    title="Edit Draft"
                    size="small"
                    sx={{ marginLeft: "15px" }}
                    onClick={() =>
                      navigate(`${locationName}/${draftedCTC.id}/edit-draft`)
                    }
                  >
                    <EditIcon />
                  </Fab>
                  <Fab
                    sx={{ marginLeft: "15px" }}
                    color="primary"
                    title="Expand/Collapse"
                    aria-label="toggle"
                    size="small"
                    onClick={() => setOpenTable(!openTable)}
                  >
                    {openTable ? "−" : "+"}
                  </Fab>
                </>
              ) : (
                <>
                  <Typography
                    gutterBottom
                    sx={{
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => navigate(`${locationName}/revise-salary`)}
                  >
                    Revise Salary
                  </Typography>

                  <Fab
                    sx={{ marginLeft: "15px" }}
                    color="primary"
                    title="Expand/Collapse"
                    aria-label="toggle"
                    size="small"
                    onClick={() => setOpenTable(!openTable)}
                  >
                    {openTable ? "−" : "+"}
                  </Fab>
                </>
              )}
            </Box>
          </Paper>

          <Collapse in={openTable} timeout="auto" unmountOnExit>
            <TableSortingAndSelect
              setFilterStatus={setFilterStatus}
              filterStatus={filterStatus}
              headCells={headCells}
              rows={filteredRows}
              setisItNewAdd={setisItNewAdd}
            />
          </Collapse>

        </>
      )}
    </Box>
  );
};
export default EmployeeReviseListData;
